import React from 'react';
import SideNavbar from './adminComponents/AdminNavbar/SideNavbar';
import AdminHome from './adminComponents/AdminHome/AdminHome'; 
import AdminAbout from './adminComponents/AdminAbout/AdminAbout';
import AdminSkills from './adminComponents/AdminSkills/AdminSkills';
import AdminProjects from './adminComponents/AdminProjects/AdminProjects';
import "./Admin.css";

function Admin() {
  return (
    <div className='admin-main'>
      <SideNavbar />
      <div className='admin-content'>
          <AdminHome />
          <AdminAbout />
          <AdminSkills />
          <AdminProjects />
      </div>
    </div>
  );
}

export default Admin;
